// src/features/leases/components/DaysRemainingPill.jsx
//
// LSE6 — colored pill showing days-until-deadline. Thresholds and palette
// come from project_lease_summary_tab_design.md § "Days-remaining pill
// treatment". null/undefined renders nothing (caller decides empty state).
// Negative values render as "Overdue" in red.

// INC-04 (LSE-STYLE-NORMALIZE-1): amber-bucket fg now routes through T.amberDark.
import React from "react";
import { T } from "../../../app/tokens.js";
import { RED_THRESHOLD_DAYS, URGENT_RED } from "../leaseTabConfig.js";
import { TERM_REMAINING_BUCKETS } from "../leasePortfolioMetrics.js";

// Issue 1 fix: day counts in pills always use thousands-comma formatting
// so "3573d" becomes "3,573d". Intl.NumberFormat is locale-aware but
// toLocaleString() is sufficient here — we just want comma separation.
function fmtDayCount(n) {
  return `${Math.abs(n).toLocaleString()}d`;
}

function paletteFor(days) {
  if (days < 0)                  return { bg: T.pillRedBg,   fg: URGENT_RED,    label: `${fmtDayCount(days)} overdue` };
  if (days < RED_THRESHOLD_DAYS) return { bg: T.pillRedBg,   fg: URGENT_RED,    label: fmtDayCount(days) };
  if (days <= TERM_REMAINING_BUCKETS.ACTIVE_3YR_PLUS.minDays) return { bg: T.ragAmberBg, fg: T.ragAmberText, label: fmtDayCount(days) };
  return                                { bg: T.pillGreenBg, fg: T.forestGreen, label: fmtDayCount(days) };
}

export function DaysRemainingPill({ days }) {
  if (days == null) return null;
  const p = paletteFor(days);
  return (
    <span
      data-testid="days-remaining-pill"
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 10px",
        borderRadius: 6,
        background: p.bg,
        color: p.fg,
        fontSize: T.fsXs,
        fontWeight: T.fwSemibold,
        lineHeight: 1.2,
      }}
    >
      {p.label}
    </span>
  );
}

// Exposed for unit tests.
export const __test = { paletteFor };
